import PageComponent from '/root/workspace/JiaMeiHuiBackstage_3hGC/src/pages/addJournalism/index';

const PageComponentName = PageComponent;

export default PageComponentName;
